var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdoLogoHorizontalGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "45.75 139.948 434.317 160.192",
    width: 434.317,
    height: 160.192,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -36.91375, 79.779015)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.62,141.84v-0.42c0-24.16-17.27-44.29-41.61-44.29c-24.37,0-41.25,19.71-41.25,43.87v0.42 c0,24.18,17.29,44.34,41.62,44.31C460.73,185.74,477.62,166.01,477.62,141.84z M359.72,141.85v-0.43 c0-41.96,32.28-76.35,76.69-76.35c44.41,0,76.27,33.97,76.27,75.92v0.42c0,41.98-32.28,76.34-76.68,76.34 C391.57,217.76,359.72,183.83,359.72,141.85z",
    style: {
      clipRule: "evenodd",
      fill: "#1E2752",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.39,173.28l32.14-32.26l-0.07-45.57h24.78c26.25,0,43.94,18.56,43.94,45.06v0.43 c0,27.6-16.97,44.5-43.95,44.5c-5.76,0-12.29,0.13-19.34,0.13l-29.56,29.69h48.91c45.82,0,77.46-32.66,77.46-74.75v-0.41 c0-42.09-31.64-74.34-77.46-74.34h-56.85V173.28z",
    style: {
      fill: "#1E2752"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "199.71,186.02 119.9,186.02 119.9,155.05 174.61,155.05 174.61,125.79 119.9,125.79 119.9,95.02  191.76,95.02 191.76,65.76 88.07,65.76 88.07,215.26 170.57,215.26 \t",
    style: {
      clipRule: "evenodd",
      fill: "#1E2752",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdoLogoHorizontalGrey);
export default __webpack_public_path__ + "static/media/edo-logo-horizontal-grey.22d80e092f3c1aa93080004f12c2960f.svg";
export { ForwardRef as ReactComponent };